import "../common.scss";

export default function Header() {
  const icon = {
    src: `${process.env.PUBLIC_URL}/images/icons/ec-icon.png`,
    alt: "Ella and Chris stamp",
  };

  return (
    <div id="header" className="header">
      <h2 className="cormorant-500 letter-spacing-5 margin-0 text-center">
        CHRIS
        <img
          className="header-icon"
          src={icon.src}
          alt={icon.alt}
          loading="lazy"
        />{" "}
        ELLA
      </h2>
    </div>
  );
}
